import React, { useEffect, useState } from 'react';
import { getAdminOrders, updateOrderStatus, getPendingOrdersCount } from '../services/api';
import { Button, Table, Alert, Badge, Spinner } from 'react-bootstrap';
import './admin/AdminShopOrders.mobile.css';

function AdminShopOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    fetchOrders();
    fetchPendingCount();
  }, []);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const res = await getAdminOrders();
      setOrders(res.data);
    } catch {
      setError('获取订单失败');
    } finally {
      setLoading(false);
    }
  };

  const fetchPendingCount = async () => {
    try {
      const res = await getPendingOrdersCount();
      setPendingCount(res.data.pending_count);
    } catch {}
  };

  const handleStatusChange = async (orderId, status) => {
    try {
      await updateOrderStatus(orderId, status);
      setSuccessMsg('订单状态已更新');
      fetchOrders();
      fetchPendingCount();
    } catch (e) {
      setError(e.response?.data?.message || '操作失败');
    }
  };

  const statusBadge = status => {
    switch (status) {
      case 'pending': return <Badge bg="warning">待发货</Badge>;
      case 'shipped': return <Badge bg="info">已发货</Badge>;
      case 'completed': return <Badge bg="success">已完成</Badge>;
      case 'refunded': return <Badge bg="secondary">已退单</Badge>;
      default: return <Badge bg="light">{status}</Badge>;
    }
  };

  return (
    <div className="container mt-4">
      <h2>订单管理 {pendingCount > 0 && <Badge bg="danger" className="ms-2 align-middle" style={{fontSize:'0.85em',padding:'2px 8px',verticalAlign:'middle'}}>待发货 {pendingCount}</Badge>}</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      {successMsg && <Alert variant="success">{successMsg}</Alert>}
      {loading ? <Spinner animation="border" /> : (
        <div className="table-responsive">
          <Table striped bordered hover className="admin-orders-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>用户</th>
                <th>昵称</th>
                <th>商品</th>
                <th>数量</th>
                <th>所需积分</th>
                <th>下单时间</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {orders.map(order => (
                <tr key={order.id}>
                  <td>{order.id}</td>
                  <td>{order.username}</td>
                  <td>{order.nickname}</td>
                  <td>{order.product_name}</td>
                  <td>{order.quantity}</td>
                  <td>{order.points_required * order.quantity}</td>
                  <td>{new Date(order.created_at).toLocaleString()}</td>
                  <td>{statusBadge(order.status)}</td>
                  <td>
                    {order.status === 'pending' && (
                      <div className="d-flex gap-1">
                        <Button size="sm" variant="info" style={{padding:'0.15em 0.7em',fontSize:'0.92em'}} onClick={() => handleStatusChange(order.id, 'shipped')}>确认发货</Button>
                        <Button size="sm" variant="secondary" style={{padding:'0.15em 0.7em',fontSize:'0.92em'}} onClick={() => handleStatusChange(order.id, 'refunded')}>退单</Button>
                      </div>
                    )}
                    {order.status === 'shipped' && (
                      <Button size="sm" variant="success" style={{padding:'0.15em 0.7em',fontSize:'0.92em'}} onClick={() => handleStatusChange(order.id, 'completed')}>完成</Button>
                    )}
                    {(order.status === 'refunded' || order.status === 'completed') && <span>-</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
}

export default AdminShopOrders;
